export function computeResult (essay, inputText) {
  let incorrectHits = 0
  let correctHits = 0
  const essaySentences = essay.split(/(\.\.\.|\.|\?|\!)/g) /* eslint-disable-line */
  const inputSentences = inputText.split(/(\.\.\.|\.|\?|\!)/g) /* eslint-disable-line */  

  let essayWords = []
  let inputWords = []
  let judgedResult = []
  let correctAnswer = []
  let className = ''

  for (let i = 0; i < inputSentences.length; i++) {
    essayWords = essaySentences[i].trim().split(' ')
    inputWords = inputSentences[i].trim().split(' ')

    for (let j = 0; j < inputWords.length; j++) {
      if (essayWords[j] && inputWords[j] === '') {
        incorrectHits += essayWords[j].length + 1
      } else {
        // 輸入的文字
        inputWords[j].split('').forEach((ch, idx) => {
          if (!essayWords[j] || essayWords[j].charAt(idx) === '') {
            incorrectHits += 1
            className = 'incorrect'
            console.log('ch:', ch)
            console.log('1')
          } else if (ch !== essayWords[j].charAt(idx)) {
            incorrectHits += 1
            className = 'incorrect'
            console.log('2')
          } else {
            correctHits += 1
            className = 'correct'
          }
          judgedResult.push({
            ch,
            className
          })
        })
      }

      if (!essayWords[j]) {
        incorrectHits += 1
      } else {
        essayWords[j].split('').forEach((ch, idx) => {
          if (j < inputWords.length - 1 || (j === inputWords.length - 1 && idx < inputWords[j].length)) {
            if (!inputWords[j] || inputWords[j].charAt(idx) === '') {
              incorrectHits += 1
              console.log('3')
              className = 'incorrect'
            } else if (ch !== inputWords[j].charAt(idx)) {
              className = 'incorrect'
            } else {
              className = 'correct'
            }
            correctAnswer.push({
              ch,
              className
            })
          }
        })
      }

      if (j < inputWords.length - 1 || inputWords.length === 1) {
        judgedResult.push({
          ch: ' ',
          className: null
        })
      }
      if (j < essayWords.length - 1 || essayWords.length === 1) {
        correctAnswer.push({
          ch: ' ',
          className: null
        })
      }
    }
  }

  return {
    incorrectHits,
    correctHits,
    judgedResult,
    correctAnswer
  }
}
